/**
 * Czyste helpery: sekrety poza IndexedDB i klasyfikacja błędów sync.
 */

const PASSWORD_KEYS = ["password", "login_password", "current_admin_password", "new_admin_password"];

export function stripSecretsFromBody(
  body: Record<string, unknown>,
): { sanitized: Record<string, unknown>; password: string | null } {
  const sanitized: Record<string, unknown> = { ...body };
  let password: string | null = null;
  for (const key of PASSWORD_KEYS) {
    const value = sanitized[key];
    if (typeof value === "string" && value.length > 0) {
      if (key === "password" && !password) {
        password = value;
      }
    }
    delete sanitized[key];
  }
  return { sanitized, password };
}

export function isAdminPasswordRejection(status: number, errorBody: unknown): boolean {
  if (status !== 403 && status !== 422) {
    return false;
  }
  const text =
    typeof errorBody === "string"
      ? errorBody
      : errorBody && typeof errorBody === "object" && "detail" in errorBody
        ? String((errorBody as { detail: unknown }).detail)
        : JSON.stringify(errorBody ?? "");
  if (/csrf/i.test(text)) {
    return false;
  }
  return /hasł|password|administrator/i.test(text);
}

export function animalsListFromReplica(data: unknown): Array<{
  tag: string;
  program_status?: string;
  [key: string]: unknown;
}> {
  if (Array.isArray(data)) {
    return data as Array<{ tag: string; program_status?: string }>;
  }
  if (data && typeof data === "object" && Array.isArray((data as { animals?: unknown }).animals)) {
    return (data as { animals: Array<{ tag: string; program_status?: string }> }).animals;
  }
  return [];
}
